module.exports = __webpack_public_path__ + "8f79d7a54d610438cc8ae580483b6168.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners/banner-persuasive.png
// module id = 2974
// module chunks = 0